<script setup lang="ts">
import { BaseButton } from '@/components/Buttons'
import ConfirmationDialog from '@/components/Modals/Dialog/ConfirmationDialog.vue'
import store from '@/store'
import { EDeviceActions } from '@/store/deviceStore/DeviceStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { EConfirmDialog } from '@/types/enum/ConfirmDialogEnum'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { EColors } from '../../../../types/constants/ColorValues'
import DeleteDeviceNameInput from './DeleteDeviceNameInput.vue'

const router = useRouter()

type Props = {
    deviceId: number
    name: string
}
const props = defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
const emit = defineEmits<Emits>()

const openDialog = ref(false)
const deviceName = ref<string>()
const isNameSimilar = computed(() => props.name === deviceName.value)

const confirmDeleteRow = () =>
    store
        .dispatch(`${EStoreModules.DEVICE}/${EDeviceActions.DELETE_DEVICE}`, {
            deviceId: props.deviceId,
            name: props.name
        })
        .then(() => {
            deviceName.value = undefined
            router
                .replace({
                    query: { ...router.currentRoute.value.query, preview: undefined }
                })
                .then(() => {
                    emit('refresh')
                    openDialog.value = false
                })
        })
</script>

<template>
    <BaseButton
        @click="openDialog = true"
        :type="EColors.DANGER"
        :label="$t('device.actions.deleteDevice')" />
    <ConfirmationDialog
        :open="openDialog"
        :type="EConfirmDialog.DELETE"
        :titleItem="name"
        :disabled="!isNameSimilar"
        @close="openDialog = false"
        @confirm="confirmDeleteRow">
        <DeleteDeviceNameInput :name="deviceName" @change="deviceName = $event" />
    </ConfirmationDialog>
</template>
